import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SlideshowService } from '../slideshow.service';
import { ApiService } from '../../shared/api.service';
import { MediaDialog } from '../images/media-dialog';
import { Utils } from '../../utils';

@Component({
    selector: 'ads-component',
    templateUrl: 'ads.component.html'
})
export class AdsComponent implements OnDestroy {
    heartbeatSubscription;
    publishSubscription;
    user;
    userCanEdit;
    static platformList = [/* add new platforms here */
        {
            descriptionCharacterLimit: 255,
            headlineCharacterLimit: 100,
            imageSizes: [{ width: 1200, height: 628 }, { width: 1080, height: 1080 }],
            name: 'Facebook',
            checked: false
        },
        {
            descriptionCharacterLimit: 100,
            headlineCharacterLimit: 50,
            imageSizes: [{ width: 1200, height: 628 }],
            name: 'Yahoo',
            checked: false
        },
        {
            headlineCharacterLimit: 100,
            imageSizes: [{ width: 1200, height: 628 }],
            name: 'Taboola',
            checked: false
        },
        {
            headlineCharacterLimit: 100,
            imageSizes: [{ width: 1200, height: 628 }],
            name: 'Outbrain',
            checked: false
        },
        {
            headlineCharacterLimit: 80,
            imageSizes: [{ width: 1200, height: 628 }],
            name: 'Baidu',
            checked: false
        },
        {
            headlineCharacterLimit: 80,
            imageSizes: [{ width: 1200, height: 628 }],
            name: 'Revcontent',
            checked: false
        }
    ];
    adImageMessages = {};
    imagesOpen = false;
    headlineCharacterLimits = [];
    descriptionCharacterLimits = [];

    constructor(
        private api: ApiService,
        private dialog: MatDialog,
        public slideshow: SlideshowService,
        public utils: Utils
    ) {
        let user = api.getProp('user');
        this.user = user;
        this.userCanEdit = true;
        this.slideshow.setupAds();
        this.slideshow.checkAdHeadlineBlackList();
        this.updateCharacterLimits();
    }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
        if( this.publishSubscription ) {
            this.publishSubscription.unsubscribe();
        }
        if (this.heartbeatSubscription) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
    createAd() {
        this.slideshow.assignment.ads.push({
            description: '',
            headline: '',
            platforms: []
        });
    }
    deleteAd(index) {
        this.slideshow.assignment.ads.splice(index, 1);
    }
    updateAdCharacterLimits(adIndex) {
        if (!this.slideshow.assignment.ads[adIndex] || this.slideshow.assignment.ads[adIndex].platforms.length === 0) {
            this.headlineCharacterLimits[adIndex] = 0;
            this.descriptionCharacterLimits[adIndex] = 0;
            return;
        }
        const matches = AdsComponent.platformList.filter(platform => this.slideshow.assignment.ads[adIndex].platforms.indexOf(platform.name) > -1);
        this.headlineCharacterLimits[adIndex] = Math.min(...matches.map(item => item.headlineCharacterLimit));
        this.descriptionCharacterLimits[adIndex] = Math.min(...matches.map(item => item.descriptionCharacterLimit || Infinity));
    }
    updateCharacterLimits() {
        this.slideshow.assignment.ads.forEach((ad, index) => { this.updateAdCharacterLimits(index); });
    }
    updateAdHeadline(adHeadline, index) {
        this.slideshow.assignment.ads[index].headline = adHeadline;
        this.slideshow.adsTabError = this.slideshow.checkAdHeadlineBlackList();
    }
    deleteAdHeadline(index) {
        this.slideshow.assignment.ads[index].headline = '';
        this.slideshow.checkAdHeadlineBlackList();
    }
    updateAdDescription(adDescription, index) {
        this.slideshow.assignment.ads[index].description = adDescription;
        this.slideshow.adsTabError = this.slideshow.checkAdHeadlineBlackList();
    }
    deleteAdDescription(index) {
        this.slideshow.assignment.ads[index].description = '';
        this.slideshow.checkAdHeadlineBlackList();
    }
    updateAdImage(event, index) {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        if (!this.slideshow.assignment.ads[index]) {
            return;
        }
        if (!event || !event.images) {
            return;
        }
        const image = typeof event.images == 'object' && !Array.isArray(event.images) ? event.images : event.images[0];
        this.slideshow.assignment.ads[index].image = image;
    }
    deleteAdImage(index) {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        this.slideshow.assignment.ads[index].image = null;
    }
    toggle(option) {
        this[option] = !this[option];
    }
    popImageDialog(image, index) {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        const dialog = this.dialog.open(MediaDialog, {
            panelClass: 'media-dialog',
            data: {
                adsTab: true,
                addToSlide: true,
                canEdit: this.userCanEdit,
                image: image,
                quiz: false
            }
        });
        dialog.afterClosed().subscribe(details => {
            if( details ) {
                this.adImageMessages = this.adImageMessages || [];
                if (details.width < 600 || details.height < 480) {
                    this.adImageMessages[index] = 'Please use a image that is at least 600x480';
                } else {
                    this.adImageMessages[index] = '';
                    this.slideshow.assignment.ads[index].image = details;
                }
            }
        });
    }
}